import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';

const DeletePropertyDialog = ({ 
  deletePropertyDialogOpen, 
  setDeletePropertyDialogOpen, 
  selectedProperty, 
  handleDeleteProperty 
}) => {
  return (
    <AnimatePresence>
      {deletePropertyDialogOpen && (
        <motion.div
          className="fixed inset-0 overflow-y-auto z-50 flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setDeletePropertyDialogOpen(false)} />
          
          <motion.div
            className="relative bg-white rounded-xl shadow-xl max-w-md w-full overflow-hidden"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: 'spring', damping: 30 }}
          >
            <div className="px-6 py-4 bg-red-600 text-white flex justify-between items-center">
              <h3 className="text-lg font-medium">Confirmar Eliminación</h3>
              <button 
                onClick={() => setDeletePropertyDialogOpen(false)}
                className="p-1 rounded-full hover:bg-white/10 transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-6">
              <div className="flex items-center justify-center mb-5">
                <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                  <AlertTriangle className="w-6 h-6 text-red-600" />
                </div>
              </div>
              
              <p className="text-center text-gray-700 mb-2">
                ¿Estás seguro de que deseas eliminar la propiedad <span className="font-semibold">{selectedProperty?.titulo}</span>?
              </p>
              <p className="text-center text-gray-500 text-sm mb-6">
                Esta acción no se puede deshacer. La propiedad se marcará como eliminada en el sistema.
              </p>
              
              <div className="flex justify-end gap-3">
                <motion.button
                  onClick={() => setDeletePropertyDialogOpen(false)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Cancelar
                </motion.button>
                
                <motion.button
                  onClick={handleDeleteProperty}
                  className="px-4 py-2 bg-red-600 text-white rounded-lg shadow-md hover:bg-red-700"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Eliminar
                </motion.button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DeletePropertyDialog;